import ArrowDown from "@/Icons/ArrowDown";
import { IconWarningContamination } from "@/Icons/WarningContamination";
import useClickoutside from "@/Utils/useClickoutside";
import type { ContaminationDetails } from "@/pages/events/types";
import { useTrans } from "@/translations";

import { useCallback, useRef, useState } from "react";

import { twMerge } from "tailwind-merge";

import { ContaminationDetailsView } from "./ContaminationDetails";

type Props = {
  eventId: string;
  contaminationDetails: ContaminationDetails;
};

export const ContaminationCellDisplay: React.FC<Props> = ({
  eventId,
  contaminationDetails,
}: Props) => {
  const { t } = useTrans();
  const containerWrapper = useRef(null);
  const [showContaminationDetails, setShowContaminationDetails] =
    useState<boolean>(false);

  const onClickContamination = useCallback(
    (e: React.MouseEvent) => {
      e.stopPropagation();
      e.preventDefault();
      setShowContaminationDetails(!showContaminationDetails);
    },
    [showContaminationDetails],
  );

  useClickoutside(containerWrapper, () => setShowContaminationDetails(false));

  return (
    <div
      className="relative flex h-[48px] w-full flex-1 cursor-pointer"
      onClick={onClickContamination}
      ref={containerWrapper}
    >
      <div className="flex w-full items-center justify-between px-2.5">
        <div className="flex items-center">
          <IconWarningContamination />
          <div className="ml-2 leading-1">
            {t("genericLabels:contaminated")}
          </div>
        </div>
        <ArrowDown
          className={twMerge(
            "overflow-visible",
            showContaminationDetails && "rotate-180",
          )}
        />
      </div>
      {showContaminationDetails && (
        <ContaminationDetailsView
          eventId={eventId}
          contaminationDetails={contaminationDetails}
        />
      )}
    </div>
  );
};
